module.exports = __webpack_public_path__ + "static/media/shuttleHeroImage.329d9e9f.png";